import React from 'react'
import { createGlobalCss, createTheme } from 'src/style/styles'
import { Global, ThemeProvider } from '@emotion/react'
import { ParallaxProvider } from 'react-scroll-parallax'
import { QueryClient, QueryClientProvider } from 'react-query'
import { alignContactForm, contactFormId } from 'src/util/alignContactForm'

const queryClient = new QueryClient()
export const wrapPageElement = ({ element, props }) => element

export const onRouteUpdate = () => {
    alignContactForm()
}

export const shouldUpdateScroll = ({ routerProps: { location } }) =>
    location.hash !== `#${contactFormId}`

const theme = createTheme()
const globalCss = createGlobalCss(theme)

export const wrapRootElement = ({ element }) => (
    <div>
        <QueryClientProvider client={queryClient}>
            <ParallaxProvider>
                <Global styles={globalCss} />
                <ThemeProvider theme={theme}>{element}</ThemeProvider>
            </ParallaxProvider>
        </QueryClientProvider>
    </div>
)

export const onClientEntry = async () => {
    if (typeof IntersectionObserver === 'undefined') {
        await import('intersection-observer')
    }
}
